<template>
    <div>
        <hero-bar :has-right-visible="false" menu-icon="desktop-mac"> {{this.$lang.Member.Update}} </hero-bar>

        <div id="app" style="padding-left: 1rem; padding-top: 1rem">
            <div class="columns">
                <!-- Member -->
                <div class="column">
                    <b style="font-size: 13px; color: #878787; padding-left: 2rem ">{{this.$lang.Member.MemberInfo}}</b>

                    <b-field style="padding-top: 1rem" horizontal :label="this.$lang.Member.Name" :type="{ 'is-danger': hasError_memberName }" :message="this.emptyWarning_memberName">
                        <b-input v-model="memberName" :maxlength="limits.firstName" style="width: 65%;"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Surname" :type="{ 'is-danger': hasError_memberSurname }" :message="this.emptyWarning_memberSurname">
                        <b-input v-model="memberSurname" :maxlength="limits.lastName" style="width: 65%;"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Email" :type="{ 'is-danger': hasError_email }" :message="this.emptyWarning_email">
                        <b-input v-model="email" type="text" :maxlength="limits.emailAddress" style="width: 65%;"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Password" :type="{ 'is-danger': hasError_password }" :message="this.emptyWarning_password">
                        <b-input v-model="password" type="password" @input="password_check" password-reveal style="width: 65%;"></b-input>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7}"><i class="frmIcon mdi" :class="password.length > 7 ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_1}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }"><i class="frmIcon mdi" :class="has_uppercase ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_2}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }"><i class="frmIcon mdi" :class="has_lowercase ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_3}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="frmIcon mdi" :class="has_number ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_4}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="frmIcon mdi" :class="has_special ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_5}}</p>
                    </b-field>

                    <b-field style="padding-top: 1rem" horizontal :label="this.$lang.Member.Password_2" :type="{ 'is-danger': hasError_password_2 }" :message="this.emptyWarning_password_2">
                        <b-input v-model="password_2" type="password" password-reveal style="width: 65%;"></b-input>
                    </b-field>
                </div>

                <!-- Company. Same field set as the registration form. -->
                <div class="column">
                    <b style="font-size: 13px; color: #878787; padding-left: 0.5rem">{{this.$lang.Member.CompanyInfo}}</b>

                    <b-field style="padding-top: 1rem" horizontal :label="this.$lang.Member.Title" :type="{ 'is-danger': hasError_title }" :message="this.emptyWarning_title">
                        <b-input v-model="title" :maxlength="limits.tradeName" style="width: 52%; padding-top: 0.5rem"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Country" :type="{ 'is-danger': hasError_country }" :message="this.emptyWarning_country">
                        <b-select v-model="country" @input="onCountryChanged()">
                            <option v-for="(option, index) in countryOptions" :value="option.name" :key="index">
                                {{ countryLabel(option) }}
                            </option>
                        </b-select>
                    </b-field>

                    <!-- The CRM requires a city only when the country is Türkiye. -->
                    <b-field horizontal v-if="isCityRequired" :label="this.$lang.Member.City" :type="{ 'is-danger': hasError_city }" :message="this.emptyWarning_city">
                        <b-select v-model="city" @input="setCityId()">
                            <option v-for="option in cityNameList" :value="option" :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Phone">
                        <div class="field" style="width: 70%;">
                            <phone-input ref="phoneInput"
                                         v-model="phone"
                                         :locale="isTr ? 'tr' : 'en'"
                                         required />
                        </div>
                    </b-field>

                    <b-field style="padding-top: 1rem">
                        <p class="control">
                            <b-button class="button is-primary" :loading="isSaving" @click="submit()">{{this.$lang.Member.UpdateBtn}}</b-button>
                        </p>
                    </b-field>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import PhoneInput from '@/components/PhoneInput.vue';
    import {
        COMM_LANGUAGE_TR_ID,
        COMM_LANGUAGE_EN_ID,
        COMM_LANGUAGE_TR_NAME,
        COMM_LANGUAGE_EN_NAME,
        COUNTRY_TURKIYE_NAME,
        isValidEmail,
        LIMITS
    } from '@/constants/registration';

    export default {
        name: 'UpdateMember',
        components: { PhoneInput },
        data() {
            return {
                isSaveBtnClicked: false,
                isSaving: false,

                memberName: '',
                memberSurname: '',
                email: '',
                password: '',
                password_2: '',
                has_number: false,
                has_lowercase: false,
                has_uppercase: false,
                has_special: false,

                title: '',
                country: '',
                countryId: '',
                countryList: [],
                city: '',
                cityId: '',
                cityList: [],
                cityNameList: [],
                phone: '',

                langList: [],
                langNameList: [],
                langId: '',
                commLanguage: '',

                limits: LIMITS,

                hasError_memberName: false,
                emptyWarning_memberName: '',
                hasError_memberSurname: false,
                emptyWarning_memberSurname: '',
                hasError_email: false,
                emptyWarning_email: '',
                hasError_password: false,
                emptyWarning_password: '',
                hasError_password_2: false,
                emptyWarning_password_2: '',
                hasError_title: false,
                emptyWarning_title: '',
                hasError_country: false,
                emptyWarning_country: '',
                hasError_city: false,
                emptyWarning_city: ''
            };
        },
        computed: {
            isTr() {
                return this.$lang.Format.Lang == 'tr-TR';
            },

            isCityRequired() {
                return this.country == COUNTRY_TURKIYE_NAME;
            },

            /**
             * The English form lists countries by their English names, but the option value
             * stays the Turkish name - that is what Members.Country holds, so a member who
             * registers in English still finds their country selected when they later open
             * the Turkish profile.
             *
             * Sorted by whatever is displayed: the list arrives in Turkish order, which
             * would scatter the English labels.
             */
            countryOptions() {
                var self = this;
                return this.countryList.slice().sort(function (a, b) {
                    return self.countryLabel(a).localeCompare(
                        self.countryLabel(b), self.isTr ? 'tr' : 'en');
                });
            },
        },
        created() {
            this.$store.state.isFooterFixed = true;
            this.getMember();
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            /* ---------- load ---------- */

            getMember() {
                api.members.getMember_2(this.$store.state.memberId).then((res) => {
                    if (res == null || res.isError || res.data == null) {
                        return;
                    }

                    var member = res.data;
                    this.memberName = member.Name;
                    this.memberSurname = member.SurName;
                    this.email = member.Email;
                    this.password = member.Passwordd;
                    this.password_2 = this.password;
                    this.password_check();
                    this.title = member.Title;
                    this.country = member.Country;
                    this.city = member.City;

                    // Stored in E.164, so it goes straight into the flag control. The old
                    // code did substring(4) here, which truncated non-Turkish numbers.
                    this.phone = member.Phone || '';

                    this.commLanguage = this.isTr ? COMM_LANGUAGE_TR_NAME : COMM_LANGUAGE_EN_NAME;
                    this.langId = this.isTr ? COMM_LANGUAGE_TR_ID : COMM_LANGUAGE_EN_ID;

                    this.getLangList();
                    this.getCountryList();
                });
            },

            getCountryList() {
                this.countryList = [];
                api.members.getCountries().then((res) => {
                    if (res == null || res.isError) {
                        return;
                    }
                    this.countryList = res.data;
                    this.resolveCountryId();

                    // The flag used to be inferred from the stored number alone, so a member
                    // whose country has no dial code - Kuzey Kıbrıs, Abkhazia - opened their
                    // profile looking at some unrelated country's flag. Telling the control
                    // which country it is also puts it into the plain box when there is no
                    // dial code to show. getMember has already set this.country by here.
                    this.$nextTick(this.syncPhoneCountry);

                    if (this.isCityRequired) {
                        this.getCityList();
                    }
                });
            },

            resolveCountryId() {
                var found = this.findCountry(this.country);
                this.countryId = found ? found.id : '';
            },

            findCountry(name) {
                for (var i = 0; i < this.countryList.length; i++) {
                    if (this.countryList[i].name === name) {
                        return this.countryList[i];
                    }
                }
                return null;
            },

            /** Falls back to the Turkish name for a country the CRM has no English name for. */
            countryLabel(option) {
                return (!this.isTr && option.englishName) ? option.englishName : option.name;
            },


            onCountryChanged() {
                this.resolveCountryId();
                this.city = '';
                this.cityId = '';
                this.cityNameList = [];
                this.cityList = [];
                if (this.isCityRequired) {
                    this.getCityList();
                }
                this.syncPhoneCountry();
            },

            /**
             * The dial code follows the country the visitor picked. Asked for by the
             * customer: choosing Germany and then being offered a +1 placeholder reads as
             * the form ignoring the answer it was just given.
             *
             * Digits already typed are kept. A country with no dial code - the CRM returns
             * a few, such as Antarctica - leaves the field untouched.
             */
            syncPhoneCountry() {
                var option = this.findCountry(this.country);
                if (option && option.sapCode && this.$refs.phoneInput) {
                    this.$refs.phoneInput.setCountry(option.sapCode);
                }
            },

            getCityList() {
                this.cityNameList = [];
                this.cityList = [];
                if (!this.countryId) {
                    return;
                }
                api.members.getCities(this.countryId).then((res) => {
                    if (res == null || res.isError) {
                        return;
                    }
                    res.data.forEach((e) => {
                        this.cityNameList.push(e.name);
                        this.cityList.push(e);
                    });
                    this.setCityId();
                });
            },

            setCityId() {
                if (this.city != '' && this.city != null) {
                    var i = this.cityNameList.indexOf(this.city);
                    this.cityId = i === -1 ? '' : this.cityList[i].id;
                }
            },

            getLangList() {
                api.members.getCommLanguages().then((res) => {
                    if (res == null || res.isError) {
                        return; // keep the constant fallback set in getMember
                    }
                    this.langNameList = [];
                    this.langList = [];
                    res.data.forEach((e) => {
                        this.langNameList.push(e.name);
                        this.langList.push(e);
                    });
                    var i = this.langNameList.indexOf(this.commLanguage);
                    if (i !== -1) {
                        this.langId = this.langList[i].id;
                    }
                });
            },

            /* ---------- validation ---------- */

            password_check() {
                this.has_number = /\d/.test(this.password);
                this.has_lowercase = /[a-z]/.test(this.password);
                this.has_uppercase = /[A-Z]/.test(this.password);
                this.has_special = /[!@#$%^&*()+=._-]/.test(this.password);
            },

            clearErrors() {
                this.hasError_memberName = false; this.emptyWarning_memberName = '';
                this.hasError_memberSurname = false; this.emptyWarning_memberSurname = '';
                this.hasError_email = false; this.emptyWarning_email = '';
                this.hasError_password = false; this.emptyWarning_password = '';
                this.hasError_password_2 = false; this.emptyWarning_password_2 = '';
                this.hasError_title = false; this.emptyWarning_title = '';
                this.hasError_country = false; this.emptyWarning_country = '';
                this.hasError_city = false; this.emptyWarning_city = '';
            },

            fail(field, message) {
                this['hasError_' + field] = true;
                this['emptyWarning_' + field] = message;
            },

            validate() {
                this.clearErrors();
                var empty = this.$lang.Menus.EmptyWarning;
                var ok = true;

                if (this.memberName.trim() == '') { this.fail('memberName', empty); ok = false; }
                if (this.memberSurname.trim() == '') { this.fail('memberSurname', empty); ok = false; }

                if (this.email.trim() == '') {
                    this.fail('email', empty); ok = false;
                } else if (!isValidEmail(this.email.trim())) {
                    this.fail('email', this.$lang.Member.EmailError); ok = false;
                }

                if (!this.isPasswordStrong()) {
                    this.fail('password', empty); ok = false;
                }
                if (this.password_2 == '' || this.password_2 != this.password) {
                    this.fail('password_2', empty); ok = false;
                }

                if (this.title.trim() == '') { this.fail('title', empty); ok = false; }

                if (this.country == '' || this.countryId == '') {
                    this.fail('country', empty); ok = false;
                }
                if (this.isCityRequired && (this.city == '' || this.cityId == '')) {
                    this.fail('city', empty); ok = false;
                }

                if (!this.validatePhone()) { ok = false; }

                return ok;
            },

            isPasswordStrong() {
                return this.password.length > 7 &&
                    this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
            },

            validatePhone() {
                var input = this.$refs.phoneInput;
                return input ? input.validate() : false;
            },

            /* ---------- submit ---------- */

            submit() {
                this.isSaveBtnClicked = true;
                if (this.isSaving || !this.validate()) {
                    return;
                }

                // Town and PhoneBusiness are not collected by this form and
                // MemberManager.UpdateMember no longer writes those columns, so whatever was
                // captured at registration survives. They are still sent, empty, because
                // MemberModel declares them as non-nullable strings and model binding
                // rejects the whole request without them - AddMember.vue does the same.
                // AllowComm is a bool, so binding defaults it and it needs no placeholder.
                var member = {
                    Id: this.$store.state.memberId,
                    Name: this.memberName.trim(),
                    SurName: this.memberSurname.trim(),
                    Email: this.email.trim(),
                    Passwordd: this.password,
                    Title: this.title.trim(),
                    Country: this.country,
                    CountryId: this.countryId,
                    City: this.city,
                    CityId: this.cityId,
                    Town: '',
                    Phone: this.phone,
                    PhoneBusiness: '',
                    CommLanguage: this.commLanguage,
                    CommLangId: this.langId
                };

                this.isSaving = true;
                api.members.encryptMember(member).then((res) => {
                    if (res == null || res.isError) {
                        this.isSaving = false;
                        return;
                    }
                    this.checkUniqueThenSave(res.data);
                });
            },

            checkUniqueThenSave(encrypted) {
                var memberId = this.$store.state.memberId;

                api.members.IsMailUnique_ForUpdate(memberId, encrypted.Email).then((mailRes) => {
                    if (mailRes == null || mailRes.isError) { this.isSaving = false; return; }
                    if (!mailRes.data) {
                        this.isSaving = false;
                        this.fail('email', this.$lang.Member.EmailError);
                        return;
                    }

                    api.members.IsPhoneNumberUnique_ForUpdate(memberId, encrypted.Phone).then((phoneRes) => {
                        if (phoneRes == null || phoneRes.isError) { this.isSaving = false; return; }
                        if (!phoneRes.data) {
                            this.isSaving = false;
                            this.$buefy.dialog.alert({
                                title: this.$lang.Member.ErrorTitle,
                                message: this.$lang.Member.MobilePhone,
                                confirmText: this.$lang.Member.ErrorClose
                            });
                            return;
                        }

                        this.save(encrypted);
                    });
                });
            },

            save(encrypted) {
                // Id is not encrypted; carry it over explicitly.
                encrypted.Id = this.$store.state.memberId;

                api.members.updateMember(encrypted).then((res) => {
                    this.isSaving = false;
                    if (res == null || res.isError) {
                        return;
                    }
                    this.$buefy.toast.open(this.$lang.Member.MemberUpdated);
                    router.push('/');
                });
            }
        }
    };
</script>
